<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="toc_h"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><b>CONTENTS</b></span></p>
<p class="toc_fm" id="pre"><a href="#/text/Preface#pref"><i>Preface</i></a></p>
<p class="toc_fm" id="loa"><a href="#/text/Abbreviations#loabb"><i>List of Abbreviations</i></a></p>
<p class="toc_fmts" id="in"><a href="#/text/Introduction#intr">Introduction</a></p>
<p class="toc_ch" id="ch01"><span href="#/text/Chapter01#ch-01" title="Link target outside of Sample">1<span class="cs">From Inclusion to Exclusion</span></span></p>
<p class="toc_ch" id="ch02"><span href="#/text/Chapter02#ch-02" title="Link target outside of Sample">2<span class="cs">Not to Be Trusted</span></span></p>
<p class="toc_ch" id="ch03"><span href="#/text/Chapter03#ch-03" title="Link target outside of Sample">3<span class="cs">The Encyclopedia and “The Falsification of History”</span></span></p>
<p class="toc_ch" id="ch04"><span href="#/text/Chapter04#ch-04" title="Link target outside of Sample">4<span class="cs">We, the Students</span></span></p>
<p class="toc_ch" id="ch05"><span href="#/text/Chapter05#ch-05" title="Link target outside of Sample">5<span class="cs">“To Warsaw Students”</span></span></p>
<p class="toc_ch" id="ch06"><span href="#/text/Chapter06#ch-06" title="Link target outside of Sample">6<span class="cs">“Zionism Is Not a Danger to Poland”</span></span></p>
<p class="toc_fm" id="con"><span href="#/text/Conclusion#conc" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc_fmts" id="ind"><span href="#/text/Index#index" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?f9b80fd0